<span [class]="'badge bg-' + variant() + (pill() ? ' rounded-pill' : '')">{{ text() }}</span>
